export default {
  MEETING_API: 'https://rs3j2vrlcl.execute-api.us-east-1.amazonaws.com/dev',
  WSS: 'wss://hm4cfpi6b0.execute-api.us-east-1.amazonaws.com/dev',
  SIGNED_API: 'https://4t7wzrz8hg.execute-api.us-east-1.amazonaws.com/dev',
  STREAM_API: 'https://bo4fz38xze.execute-api.us-east-1.amazonaws.com/dev/dev',
  QUESTIONS_CF_API: 'https://.cloudfront.net',
};
